import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge44 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='リゾート会員権とは？' fontWeight={700} />
                <p>
                    リゾート会員権とは、リゾートホテルやリゾート施設を会員向けの条件で利用できる権利の総称です。ゴルフ会員権とは別の仕組みであり、リゾート会員権＝ゴルフ会員権という意味ではありません。
                    <br />
                    会員権の内容は運営会社ごとに異なり、1年のうち決まった日数・期間の利用権を持つタイムシェア（バケーションオーナーシップ）型など、さまざまな形態があります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='リゾート会員権の主な特徴' fontWeight={700} />
                <Heading3 title='宿泊施設の優待利用' />
                <p>
                    会員向けの優待料金で宿泊できたり、年間の利用日数が設けられていたりするなど、会社ごとに独自の特典が用意されています。ただし、すべてのホテルで優待料金が適用されるとは限らず、宿泊可能日数も一律に保証されているわけではありません。
                </p>
                <Heading3 title='ゴルフ場を利用できる優待が付くケースも' />
                <p>
                    リゾート会員権の中には、特典の一つとして系列・提携のゴルフ場を利用できる優待が付いているケースもあります。
                    <br />
                    例えば、リゾートトラストグループでは、ゴルフ会員がエクシブなどの系列ホテルに年間2泊できる特典があります（詳しくは
                    <a href='/knowledge/43'>こちらの記事</a>
                    でご紹介しています）。
                </p>
                <Heading3 title='会員権の形態はグループにより異なる' />
                <p>
                    リゾート会員権と一口にいっても、預託金制・株式会員制・利用権型など会員権の形態は会社やグループによって異なります。
                    <br />
                    購入を検討する際は、宿泊施設やゴルフ場の優待内容・利用条件も含めて比較することが重要です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='リゾート会員権を検討する際の注意点' fontWeight={700} />
                <p>
                    リゾート施設の優待特典は魅力的である一方、優待料金の適用有無や宿泊可能日数は会社・施設・会員権の種類によって異なり、繁忙期の利用制限や追加費用、対象者の制限（本人及び配偶者のみなど）が設けられていることが一般的です。
                    <br />
                    購入前には、優待の対象範囲・適用される料金・宿泊可能日数・ゴルフ場優待の有無や条件などを必ず確認するようにしましょう。
                    <br />
                    また、名義書換や譲渡の可否は会員権によって異なるため、将来的な売却を見据えている場合は特に注意が必要です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    リゾート会員権をご検討の際は、グループごとの特典内容や会員権の形態、売買状況について弊社にお気軽にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge44;
